import React, { useState, useEffect, useContext }  from "react";

import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { process, orderBy } from "@progress/kendo-data-query";

import { AppContext } from "../../AppContext";
import DataRenderer from "../../common/dataRenderer";
import StatusComp from "../../common/StatusComp";

const ObaGridComp = (props)=>{
    const [appContext, setAppContext] = useContext(AppContext);
    const isJwCole = appContext.clientId === "jwcole"?true:false;
    
    const initGridSortState = {
        sort: [{ field: "requestDateTime", dir: "desc" }]
      };

      const initGridPagingState = {
        take: props.dataFrame.limit,
        skip: props.dataFrame.startIndex,
        pageable: {
          buttonCount: 5,
          info: true,
          type: "numeric",
          pageSizes: true,
          previousNext: true,
        },
      };


      const [gridSortState, setGridSortState] = useState(initGridSortState);
      const [gridPagingState, setGridPagingState] = useState(initGridPagingState);
    
      const onGridSortStateChange = (e) => {
        setGridSortState({
          ...gridSortState,
          sort: e.sort,
        });
      };
    
      const onGridPagingStateChange = (e) => {
        props.setDataFrame(p => { return { ...p, startIndex: e.page.skip, limit: e.page.take } })
      };
    
      useEffect(() => {
        setGridPagingState({
          ...gridPagingState,
          skip: props.dataFrame.startIndex,
          take: props.dataFrame.limit,
        });
      }, [props.dataFrame]);
    
    
      const handleRowClick = (e) => {
        props.onDetail(e.dataItem.id);
      };
    
      const statusCell = (cellProps) => {

        const handleCellClick = (dataItem) => {
          props.onDetail(dataItem.id);
        };

        return (
          <td onClick={() => handleCellClick(cellProps.dataItem)}>
            <StatusComp status={cellProps.dataItem.status}>{cellProps.dataItem.statusLabel}</StatusComp>
          </td>
        );
      };
    
    
      const quantityCell = (props) => {
        return (<td>{DataRenderer.numberToFixed(props.dataItem.quantity, 4)} </td>);
      };
      const createdTimestampCell = (props) => {
        return (<td>{DataRenderer.dateStrStripDate(props.dataItem.createdTimeStampUserTz)} </td>);
      };

      const getEmpTradeRequests = (sort) => {
        let items = props.items.map(x => (
          { ...x,
            requestDateTime: new Date(x.createdTimeStampUserTz)
          })
        );
        return orderBy(items, sort);
      }

    return (
        <Grid
            sortable
            sort={gridSortState.sort}
            onSortChange={onGridSortStateChange}
            data={getEmpTradeRequests(gridSortState.sort).slice(
                gridPagingState.skip,
                gridPagingState.take + gridPagingState.skip
            )}
            resizable
            skip={gridPagingState.skip}
            take={gridPagingState.take}
            total={props.items.length}
            pageable={gridPagingState.pageable}
            onPageChange={onGridPagingStateChange}
            reorderable
            onRowClick={handleRowClick}
            >
            <Column width="160" field="requestDateTime" title="Request Date" cell={createdTimestampCell} />
            <Column field="giftType" title="Gift Type" />
            <Column field="address" title="Address" />
            <Column field="giftValue" title="Gift Value" />
            <Column field="recipients" title="Recipients" />
            { isJwCole && <Column field="providers" title="Provider(s)" />}
            <Column field="description" title="Description" />
            {(localStorage.getItem("ENABLE_CREATE_ON_BEHALF")==='true') && <Column field="employeeName" title="Employee" />}
            {(localStorage.getItem("ENABLE_CREATE_ON_BEHALF")==='true') && <Column field="submittedBy" title="Submitted By" />}
            <Column width="220" field="status" title="Request Status" cell={statusCell} />
        </Grid>
    );

};


export default ObaGridComp;